<template>
  <esg-base-dashboard-card title="에너지 사용량"
                           subtitle="(전사 - 에너지원 단위 - 과거 3개년)">
    <!-- 문경태 팀장님 요청에 의해 삭제 -->
    <!-- <template #actions>
      <b-form inline>
        <esg-base-select-box v-model="sort"
                             label="정렬"
                             size="sm">
          <option value="asc">오름차순</option>
          <option value="dsc">내림차순</option>
        </esg-base-select-box>
      </b-form>
    </template> -->

    <firmwide-energy-by-fuel :sort="sort"
                             height="250px"
                             @dataPointSelection="onDataPointSelection"/>
  </esg-base-dashboard-card>
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import FirmwideEnergyByFuel from "@/components/esg/3. Monitoring/charts2/FirmwideEnergyByFuel.vue";
import EsgBaseSelectBox from "@/components/esg/base/form/EsgBaseSelectBox.vue";

export default {
  name: "SortableFirmwideEmissionByCorp",
  components: {EsgBaseSelectBox, FirmwideEnergyByFuel, EsgBaseDashboardCard},
  data() {
    return {
      sort: 'dsc',
    }
  },
  methods: {
    onDataPointSelection() {
      this.$emit('dataPointSelection');
    }
  }
}
</script>